import React, { useState, useEffect} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingAnimation from "../../Components/Loading/LoadingAnimation";
import { Combobox } from "@headlessui/react";
import { ChevronUpDownIcon} from "@heroicons/react/20/solid";
import { FETCH_PERMISSION_URL } from "../../Constants/apiRoutes";
import { CREATE_OR_UPDATE_ROLE_URL } from "../../Constants/apiRoutes";
import { toast, ToastContainer } from "react-toastify";
const functions = [
  { id: 1, name: "Technical Function" },
  { id: 2, name: "Finance" },
  { id: 3, name: "Human Resources" },
  { id: 4, name: "Marketing" },
  { id: 5, name: "Sales" },
  { id: 6, name: "Projects" },
  { id: 7, name: "Legal" },
  { id: 8, name: "Management"},
  { id: 9, name: "Others" },
];
const AddRoleForm = () => {
  const [formData, setFormData] = useState({
    roleName: "",
    companyName: "",
    businessUnit: "",
    selectedFunctions: [],
  });

  const [permissionsByModule, setPermissionsByModule] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [query, setQuery] = useState("");

  const navigate = useNavigate();
  const filteredFunctions =
    query === ""
      ? functions
      : functions.filter((func) =>
          func.name.toLowerCase().includes(query.toLowerCase())
        );

  const handleSelectAll = () => {
    setFormData((prev) => {
      // If all already selected, unselect all
      const allSelected =
        prev.selectedFunctions.length === filteredFunctions.length;
      return {
        ...prev,
        selectedFunctions: allSelected ? [] : filteredFunctions,
      };
    });
  };
  const handleFunctionChange = (func) => {
    setFormData((prev) => {
      const isSelected = prev.selectedFunctions.some(
        (item) => item.id === func.id
      );
      const updated = isSelected
        ? prev.selectedFunctions.filter((item) => item.id !== func.id)
        : [...prev.selectedFunctions, func];

      return {
        ...prev,
        selectedFunctions: updated,
      };
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchPermissions = async () => {
      const token = localStorage.getItem("token");
      try {
        setLoading(true);

        const response = await axios.get(FETCH_PERMISSION_URL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data;
        const categorizedPermissions = {};

        if (data.Permissions && Array.isArray(data.Permissions)) {
          data.Permissions.forEach((permission) => {
            if (!categorizedPermissions[permission.Module]) {
              categorizedPermissions[permission.Module] = [];
            }
            categorizedPermissions[permission.Module].push(permission);
          });
        }

        setPermissionsByModule(categorizedPermissions);
      } catch (err) {
        setError("Failed to fetch permissions");
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  // let roleData = {
  //   roleId: 0,
  //   roleName: roleName,
  //   permissions: [],
  // };
  const handleCheckboxChange = (moduleName, permissionId) => {
    setPermissionsByModule((prevState) => {
      const updatedPermissions = { ...prevState };
      updatedPermissions[moduleName] = updatedPermissions[moduleName].map(
        (permission) =>
          permission.ID === permissionId
            ? { ...permission, IsChecked: !permission.IsChecked }
            : permission
      );
      return updatedPermissions;
    });
  };

  const handleSelectAllChange = (moduleName, isChecked) => {
    setPermissionsByModule((prevState) => {
      const updatedPermissions = { ...prevState };
      updatedPermissions[moduleName] = updatedPermissions[moduleName].map(
        (permission) => ({
          ...permission,
          IsChecked: isChecked,
        })
      );
      return updatedPermissions;
    });
  };

  const handleClose = () => {
    navigate("/RoleUser");
  };

  if (error) return <div>{error}</div>;
  const handleSaveRole = async (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");
    const TenantID = localStorage.getItem("TenantID");
    // ✅ Extract selected function IDs to send as DepartmentIds
    // const DepartmentIds = formData.selectedFunctions.map((f) => f.id);
    const DepartmentIds = formData.selectedFunctions
    .map((f) => f.id)
    .filter((id) => id !== null && id !== undefined);
  
    const roleData = {
      RoleID: 0,
      TenantID: TenantID,
      RoleName: formData.roleName,
      CompanyName: formData.companyName,
      DepartmentIds: DepartmentIds,
       Status: formData.isActive,
      BusinessUnit: formData.businessUnit,
      permissions: [],
    };

    // Validation
    const validateRoleDataSubmit = () => {
      const newErrors = {};
      if (!roleData.RoleName)
        newErrors.RoleNameError = "Role Name is required.";
      if (!roleData.CompanyName)
        newErrors.CompanyNameError = "Company Name is required.";
      if (roleData.DepartmentIds.length === 0)
        newErrors.DepartmentIdsError = "Select at least one department.";
      setErrors(newErrors);
      return Object.keys(newErrors).length > 0;
    };

    if (validateRoleDataSubmit()) return;

    // Collect permissions
    Object.keys(permissionsByModule).forEach((module) => {
      permissionsByModule[module].forEach((permission) => {
        roleData.permissions.push({
          permissionId: permission.ID,
          isChecked: permission.IsChecked,
        });
      });
    });

    try {
      setLoading(true);
      const response = await axios.post(CREATE_OR_UPDATE_ROLE_URL, roleData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Show success message and redirect
      toast.success("User Role saved successfully!");
      setTimeout(() => {
        navigate("/roleuser");
      }, 1000);
    } catch (error) {
      console.error(error);
    const errorMessage =
    error?.response?.data?.message || "Error saving role. Please try again.";

  setErrors({ saveError: errorMessage });
  toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`main-container`}>
      <div className=" p-6 rounded-lg ">
        <ToastContainer />
        {loading && <LoadingAnimation />}

        {/* <div className="mt-6 bg-white p-6 rounded-lg shadow-md"> */}
  <div className="flex items-center justify-between w-full mb-4">
  <h2 className="text-xl font-semibold">Add Role</h2>

  <div className="flex items-center space-x-2">
    <label className="font-semibold">Is Active:</label>
    <div
      onClick={() =>
        setFormData((prevData) => ({
          ...prevData,
          isActive:
            prevData.isActive === "Active" ? "Inactive" : "Active",
        }))
      }
      className={`relative w-14 h-6 rounded-full cursor-pointer transition ${
        formData.isActive === "Active" ? "bg-green-500" : "bg-red-500"
      }`}
    >
      <div
        className={`absolute top-1/2 left-1 transform -translate-y-1/2 w-5 h-5 bg-white rounded-full shadow-md transition-transform ${
          formData.isActive === "Active"
            ? "translate-x-8"
            : "translate-x-0"
        }`}
      ></div>
    </div>
  </div>
</div>


        <hr className="border-gray-300 my-4 mb-4" />
        <div className="mb-4 flex flex-col sm:flex-row items-center justify-center w-full">
          {/* Role Name Field */}
          <div className="flex flex-col sm:flex-row items-center w-full sm:w-1/2">
            <label className="block font-semibold mr-[14px] min-w-[150px] text-right whitespace-nowrap">
              Role Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="roleName"
              value={formData.roleName}
              onChange={handleInputChange}
              className={`border ${
                errors.RoleNameError && !formData.roleName
                  ? "border-red-500"
                  : "border-gray-300"
              } p-2 w-full rounded-md`}
              placeholder="Enter Role Name"
            />
          </div>

          {/* Company Name Field */}
          <div className="flex flex-col sm:flex-row items-center w-full sm:w-1/2">
            <label className="block font-semibold mr-[14px] min-w-[150px] text-right whitespace-nowrap">
              Company Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
              className={`border ${
                errors.CompanyNameError && !formData.companyName
                  ? "border-red-500"
                  : "border-gray-300"
              } p-2 w-full rounded-md`}
              placeholder="Enter Company Name"
            />
          </div>
        </div>
        <div className="mb-4 flex flex-col sm:flex-row items-center justify-center w-full">
          {/* Function Field (Now has the same width as Role & Company Name) */}
          <div className="flex flex-col sm:flex-row items-center w-full sm:w-1/2">
            <label className="block font-semibold mr-[14px] min-w-[150px] text-right whitespace-nowrap">
              Function <span className="text-red-500">*</span>
            </label>
            <Combobox
              as="div"
              value={formData.selectedFunctions}
              onChange={(value) => handleFunctionChange(value)}
              multiple
              className="w-full"
            >
              <div className="relative w-full">
                <Combobox.Input
                  id="FunctionID"
                  name="FunctionID"
                  className="block w-full border border-gray-300 p-2 rounded-md shadow-sm sm:text-sm focus:outline-none"
                  displayValue={() =>
                    formData.selectedFunctions.map((f) => f.name).join(", ") ||
                    "Select Function"
                  }
                  placeholder="Select Function"
                  readOnly
                />
                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center px-2">
                  <ChevronUpDownIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </Combobox.Button>

                <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {/* ✅ Select All Option */}
                  <Combobox.Option
                    key="select-all"
                    value="select-all"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectAll();
                    }}
                    className="group relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-indigo-100"
                  >
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={
                          formData.selectedFunctions.length ===
                          filteredFunctions.length
                        }
                        readOnly
                        className="mr-2 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                      <span className="block truncate">Select All</span>
                    </div>
                  </Combobox.Option>

                  {/* 🔁 Map each individual function */}
                  {filteredFunctions.map((func) => {
                    const isSelected = formData.selectedFunctions.some(
                      (item) => item.id === func.id
                    );
                    return (
                      <Combobox.Option
                        key={func.id}
                        value={func}
                        onClick={() => handleFunctionChange(func)}
                        className={`group relative cursor-pointer select-none py-2 pl-3 pr-9 ${
                          isSelected
                            ? "bg-indigo-600 text-white"
                            : "text-gray-900"
                        }`}
                      >
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            className="mr-2 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                          />
                          <span className="block truncate">{func.name}</span>
                        </div>
                      </Combobox.Option>
                    );
                  })}
                </Combobox.Options>
              </div>
            </Combobox>
          </div>

          <div className="flex flex-col sm:flex-row items-center w-full sm:w-1/2">
            <label className="block font-semibold mr-[14px] min-w-[150px] text-right whitespace-nowrap">
              Business Unit <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="businessUnit"
              value={formData.businessUnit}
              onChange={handleInputChange}
              className={`border ${
                errors.BusinessUnitError && !formData.businessUnit
                  ? "border-red-500"
                  : "border-gray-300"
              } p-2 w-full rounded-md`}
              placeholder="Enter Business Unit"
            />
          </div>
        </div>
        <hr className="border-gray-300 my-4 mb-6" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Object.keys(permissionsByModule).map((moduleName) => {
            const isAllSelected = permissionsByModule[moduleName].every(
              (permission) => permission.IsChecked
            );

            return (
              <div
                key={moduleName}
                className="border-[0.5px] border-[#ce8c5d] p-4 rounded-lg bg-white shadow-md"
              >
                <div className="flex justify-between items-center">
                  <h2 className="text-lg font-bold text-[#8B4513]">
                    {moduleName}
                  </h2>
                  <label className="text-sm flex items-center">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={(e) =>
                        handleSelectAllChange(moduleName, e.target.checked)
                      }
                      className="mr-2 form-checkbox h-[12px] w-[12px] text-[#8B4513] border-[#8B4513]"
                    />
                    Select All
                  </label>
                </div>
                <hr className="border-[#8B4513] opacity-20 my-4 mt-2 mb-4" />

                {permissionsByModule[moduleName].map((permission) => (
                  <div key={permission.ID} className="flex items-center mb-2">
                    <label className="flex items-center text-gray-700">
                      <input
                        type="checkbox"
                        checked={permission.IsChecked}
                        onChange={() =>
                          handleCheckboxChange(moduleName, permission.ID)
                        }
                        className="mr-2 form-checkbox h-[12px] w-[12px] text-[#8B4513] border-[#8B4513]"
                      />
                      {permission.Name}
                    </label>
                  </div>
                ))}
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row justify-end space-y-4 sm:space-y-0 sm:space-x-4">
          <button
            onClick={handleClose}
            className="flex items-center justify-center px-4 py-2 bg-gradient-to-br from-[#8B4513] to-[#D2691E] text-white rounded-lg hover:from-[#A0522D] hover:to-[#D2691E] transition-all duration-300 w-full sm:w-auto"
          >
            Close
          </button>

          <button
            onClick={handleSaveRole}
            className="flex items-center justify-center px-4 py-2 bg-gradient-to-br from-[#8B4513] to-[#D2691E] text-white rounded-lg hover:from-[#A0522D] hover:to-[#D2691E] transition-all duration-300 w-full sm:w-auto"
          >
            Save Role
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRoleForm;
